import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from "components/anexo/AnexoPanel";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import InputMonetario from "components/input/InputMonetario";
import { Label } from "components/input/Label";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import ItemNotaFiscalEntrada from "model/suprimentos/ItemNotaFiscalEntrada";
import NotaFiscalEntrada from "model/suprimentos/NotaFiscalEntrada";
import ProdutoCadastro from "pages/administracao/cadastro/produto/ProdutoCadastro";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnBodyOptions, ColumnEditorOptions } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import NotaFiscalEntradaService from "service/suprimentos/NotaFiscalEntradaService";
import { pessoaCompleteMethod, pessoaItemTemplate, produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";
import { converterData, converterDataHora } from "utils/convert";
import PatrimonioPorNotaModal from "./PatrimonioPorNotaModal";

const notaFiscalEntradaService = new NotaFiscalEntradaService();

export default function NotaFiscalEntradaCadastro() {

    const refValorUnitario = useRef(null);

    const { setError, setFocus, control, clearErrors, register, formState: { errors } } = useForm();

    const [queryParameters] = useSearchParams();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const [notaFiscalEntrada, setNotaFiscalEntrada] = useState<NotaFiscalEntrada>(new NotaFiscalEntrada());
    const [titulo, setTitulo] = useState<string>('Nota Fiscal de Entrada');

    const [alterando, setAlterando] = useState<boolean>(false);
    const [temPatrimonio, setTemPatrimonio] = useState<boolean>(false);
    const [soPatrimonio, setSoPatrimonio] = useState<boolean>(false);
    const [depositos, setDepositos] = useState<any[]>([]);
    const [produtos, setProdutos] = useState<any[]>([]);
    const [locais, setLocais] = useState<any[]>([]);
    const [produtosPatrimoniaveis, setProdutosPatrimoniaveis] = useState<any[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<any[]>([]);
    const [fornecedores, setFornecedores] = useState<any[]>([]);
    const [fornecedoresFiltrados, setFornecedoresFiltrados] = useState<any[]>([]);
    const [transacoes, setTransacoes] = useState<any[]>([]);
    const [patrimonioModal, setPatrimonioModal] = useState<{ visible: boolean, itemNota: ItemNotaFiscalEntrada, rowIndex: number }>({ visible: false, itemNota: new ItemNotaFiscalEntrada(), rowIndex: -1 });
    const [contador, setContador] = useState<number>(0);

    const [visibleCadastroProduto, setVisibleCadastroProduto] = useState<boolean>(false);

    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);
    const [anexos, setAnexos] = useState([]);

    const [editando, setEditando] = useState<boolean>(false);

    function validar() {
        if (!notaFiscalEntrada.numero || notaFiscalEntrada.numero === 0) {
            setError("numero", { type: "manual", message: "Numero da nota fiscal é obrigatório" }, { shouldFocus: true });
            msgAlerta("Informe o número", "Número da nota fiscal é obrigatório");
            return false;
        }
        if (!notaFiscalEntrada.fornecedor || !notaFiscalEntrada.fornecedor?.nome || !notaFiscalEntrada.fornecedor?.codigoInterno) {
            setError("fornecedor", { type: "manual", message: "Fornecedor é obrigatório" }, { shouldFocus: true });
            msgAlerta("Informe o fornecedor", "Fornecedor é obrigatório");
            return false;
        }
        if (!notaFiscalEntrada.transacao || !notaFiscalEntrada.transacao?.codigo) {
            setError("transacao", { type: "manual", message: "Transação é obrigatório" }, { shouldFocus: true });
            msgAlerta("Informe a transação", "Transação é obrigatório");
            return false;
        }
        if (notaFiscalEntrada.itens.length === 0) {
            msgAlerta("Informe os itens", "Itens são obrigatórios");
            return false;
        }

        for (let i = 0; i < notaFiscalEntrada.itens.length; i++) {
            if (!notaFiscalEntrada.itens[i].produto || !notaFiscalEntrada.itens[i].produto?.codigo) {
                msgAlerta("Informe o produto no item " + (i + 1), "Produto é obrigatório");
                return false;
            }
            if (notaFiscalEntrada.itens[i].itemPatrimonio) {
                if (!notaFiscalEntrada.itens[i].local || !notaFiscalEntrada.itens[i].local?.nome) {
                    msgAlerta("Informe o depósito no item " + (i + 1), "Depósito é obrigatório");
                    return false;
                }
            } else {
                if (!notaFiscalEntrada.itens[i].deposito || !notaFiscalEntrada.itens[i].deposito?.nome) {
                    msgAlerta("Informe o depósito no item " + (i + 1), "Depósito é obrigatório");
                    return false;
                }

                if (notaFiscalEntrada.itens[i].lote === "") {
                    msgAlerta("Informe o lote no item " + (i + 1), "Lote é obrigatório");
                    return false;
                }

                if (notaFiscalEntrada.itens[i].valorUnitario === 0) {
                    msgAlerta("Informe o valor unitário no item " + (i + 1), "Valor unitário é obrigatório");
                    return false;
                }
            }
            if (notaFiscalEntrada.itens[i].quantidade === 0) {
                msgAlerta("Informe a quantidade no item " + (i + 1), "Quantidade é obrigatório");
                return false;
            }
        }

        return true;
    }


    useEffect(() => {
        if (isEditando()) {
            setEditando(true);
        }
        notaFiscalEntradaService.getProdutosComprados().then((data) => {
            setProdutos(data);
        }).catch((error) => {
            console.log(error);
        });

        notaFiscalEntradaService.getProdutosPatrimoniaveis().then((data) => {
            setProdutosPatrimoniaveis(data);
        }).catch((error) => {
            console.log(error);
        });

        notaFiscalEntradaService.getFornecedores().then((data) => {
            console.log(data)
            setFornecedores(data);
        }).catch((error) => {
            console.log(error);
        });

        notaFiscalEntradaService.getDepositos().then((data) => {
            setDepositos(data);
        }).catch((error) => {
            console.log(error);
        });

        notaFiscalEntradaService.getLocais().then((data) => {
            setLocais(data);
        }).catch((error) => {
            console.log(error);
        });

        notaFiscalEntradaService.getTransacoes().then((data) => {
            setTransacoes(data);
        }).catch((error) => {
            console.log(error);
        });
        if (!isEditando()) {
            notaFiscalEntradaService.getTransacaoPadrao().then((data) => {
                if (data) setNotaFiscalEntrada({ ...notaFiscalEntrada, transacao: data });
            }).catch((error) => {
                console.log(error);
            });
        }

    }, [])

    useEffect(() => {
        if (notaFiscalEntrada.itens != null) {
            if (notaFiscalEntrada.itens.every(item => item.itemPatrimonio)) {
                setSoPatrimonio(true);
            } else {
                setSoPatrimonio(false);
            }
            if (notaFiscalEntrada.itens.some(item => item.itemPatrimonio)) {
                setTemPatrimonio(true);
            } else {
                setTemPatrimonio(false);
            }
        }
        console.log(notaFiscalEntrada);
    }, [notaFiscalEntrada]);

    function isEditando() {
        return window.location.pathname !== '/notaFiscalEntrada/cadastrar';
    }

    const consultar = () => {
        notaFiscalEntradaService.consultar(notaFiscalEntrada.id)
            .then((data: NotaFiscalEntrada) => {
                setAlterando(false);
                setNotaFiscalEntrada(data);
            }).catch((e) => console.error(e));
    }

    const produtoEditor = (options: ColumnEditorOptions) => {
        return (
            <AutoComplete
                value={options.rowData.produto}
                placeholder="Selecione um Componente"
                style={{ width: '100%' }}
                field="nome"
                itemTemplate={(item: Produto) => produtoItemTemplate(item)}
                suggestions={produtosFiltrados}
                completeMethod={(e) => {
                    let filtered: Produto[];
                    if (options.rowData.itemPatrimonio) {
                        filtered = produtoCompleteMethod(produtosPatrimoniaveis, e.query);
                    } else {
                        filtered = produtoCompleteMethod(produtos, e.query);
                    }
                    setProdutosFiltrados(filtered);
                }}
                onChange={(e) => {
                    console.log(e)
                    let notaLocal = JSON.parse(JSON.stringify(notaFiscalEntrada));
                    if (typeof e.target.value == "string") {
                        let prod = new Produto();
                        prod.nome = e.target.value;
                        notaLocal.itens[options.rowIndex].produto = prod;
                    } else {
                        notaLocal.itens[options.rowIndex].produto = e.target.value;

                    }
                    setAlterando(true);
                    options.rowData['produto'] = notaLocal.itens[options.rowIndex].produto;

                    setNotaFiscalEntrada(notaLocal);
                }}

            />
        );
    }

    const depositoEditor = (options: ColumnEditorOptions) => {
        return (
            <Dropdown value={options.rowData.deposito} options={depositos} optionLabel="nome" onChange={(e) => {
                options.rowData['deposito'] = e.value;
                let notaLocal = { ...notaFiscalEntrada };
                notaFiscalEntrada.itens[options.rowIndex] = options.rowData;
                setAlterando(true);
                setNotaFiscalEntrada(notaLocal);
            }} style={{ width: '100%' }} />
        );
    }

    const localEditor = (options: ColumnEditorOptions) => {
        return (
            <Dropdown value={options.rowData.local} options={locais} optionLabel="nome" onChange={(e) => {
                options.rowData['local'] = e.value;
                let notaLocal = { ...notaFiscalEntrada };
                notaFiscalEntrada.itens[options.rowIndex] = options.rowData;
                setAlterando(true);
                setNotaFiscalEntrada(notaLocal);
            }} style={{ width: '100%' }} />
        );
    }

    const quantidadeEditor = (options: ColumnEditorOptions) => {
        return (
            <InputNumber value={options.rowData.quantidade}
                useGrouping={false}
                maxFractionDigits={5}
                minFractionDigits={0}
                maxLength={15}
                onChange={(e) => {
                    onChangeItem(options, e.value);
                    setAlterando(true);
                }}
                style={{ width: '100%' }} />
        );
    }

    const valorUnitarioEditor = (options: ColumnEditorOptions) => {
        return (
            <InputMonetario disabled={options.rowData.itemPatrimonio} value={options.rowData.valorUnitario} onChange={(e) => {
                onChangeItem(options, e);
            }} />
        )
    };

    const loteEditor = (options: ColumnEditorOptions) => {
        return (
            <InputText maxLength={50} disabled={options.rowData.itemPatrimonio} value={options.rowData.lote} onChange={(e) => {
                onChangeItem(options, e.target.value);
            }} />
        );
    }

    const validadeEditor = (options: ColumnEditorOptions) => {
        return (
            <Calendar locale="pt-BR" dateFormat="dd/mm/yy" disabled={options.rowData.itemPatrimonio} value={options.rowData.validade} onChange={(e) => {
                onChangeItem(options, e.value);
            }} style={{ width: '100%' }} />
        );
    }


    const onChangeItem = (options: ColumnEditorOptions, value: any) => {
        options.rowData[options.field] = value;
        let notaLocal = { ...notaFiscalEntrada };
        notaFiscalEntrada.itens[options.rowIndex] = options.rowData;
        setAlterando(true);
        setNotaFiscalEntrada(notaLocal);

    }

    const botoesExtra = <>
        <Button type="button" label="Adicionar Produto" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => { setVisibleCadastroProduto(true) }}></Button>
        <Button disabled={!notaFiscalEntrada.id || alterando} type="button" label="Fechar" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => {
            temPatrimonio ? beforeFechar() : fecharNota();
        }}></Button>
        <Button disabled={!notaFiscalEntrada.id || alterando} type="button" label="Reabrir" className="ui-button-info" style={{ marginLeft: 8 }} onClick={() => {
            reabrirNota();
        }}></Button>
    </>

    const fecharNota = () => {
        startLoading();
        if (notaFiscalEntrada.id) {
            fecharNotaFiscal(notaFiscalEntrada);
        }
    }

    const limparPatrimoniosDosItens = () => {
        setNotaFiscalEntrada(prevNotaFiscalEntrada => ({
            ...prevNotaFiscalEntrada,
            itens: prevNotaFiscalEntrada.itens.map(item => ({
                ...item,
                patrimonios: []
            }))
        }));
    };

    function fecharNotaFiscal(notaFiscalEntrada: NotaFiscalEntrada) {
        notaFiscalEntradaService.fechar(notaFiscalEntrada).then((data) => {
            msgSucesso("Nota Fiscal de Entrada", "Nota fiscal de entrada fechada com sucesso");
            setNotaFiscalEntrada(data);
            consultarModeloGravado(data);
            stopLoading();
        }).catch((error) => {
            setContador(0);
            limparPatrimoniosDosItens();
            stopLoading();
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro("Nota Fiscal de Entrada", error.data.message);
            } else {
                msgErro("Nota Fiscal de Entrada", "Ocorreu um erro ao tentar fechar, tente novamente!");
            }
        });
    }

    function consultarModeloGravado(model: NotaFiscalEntrada) {
        let ident = model.id ? model.id : model.codigo;
        notaFiscalEntradaService.consultar(ident || 0).then((modelParam: NotaFiscalEntrada) => {
            setNotaFiscalEntrada(modelParam);

        }).catch(error => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro("Consulta", error.data.message);
            } else {
                msgErro("Consulta", 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        });
    }

    const reabrirNota = () => {
        startLoading();
        if (notaFiscalEntrada.id) {
            notaFiscalEntradaService.reabrir(notaFiscalEntrada).then((data) => {
                msgSucesso("Nota Fiscal de Entrada", "Nota fiscal de entrada reaberta com sucesso");
                consultarModeloGravado(data);
                setContador(0);
                limparPatrimoniosDosItens();
                stopLoading();
            }).catch((error) => {
                stopLoading();
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro("Nota Fiscal de Entrada", error.data.message);
                } else {
                    msgErro("Nota Fiscal de Entrada", "Ocorreu um erro ao tentar reabrir, tente novamente!");
                }
            });
        }
    }

    const notaPatrimonio = () => {
        setSoPatrimonio(notaFiscalEntrada.itens.every(item => item.itemPatrimonio))
        setTemPatrimonio(notaFiscalEntrada.itens.some(item => item.itemPatrimonio))
    }

    const beforeFechar = () => {
        
        for (let i = 0; i < notaFiscalEntrada.itens.length; i++) {
            if (notaFiscalEntrada.itens[i].itemPatrimonio  && (!notaFiscalEntrada.itens[i].patrimonios)) {
                setPatrimonioModal({ visible: true, itemNota: notaFiscalEntrada.itens[i], rowIndex: i })
                return
            }
        }
        setPatrimonioModal({ visible: false, itemNota: new ItemNotaFiscalEntrada(), rowIndex: -1 })
        fecharNota();
    }

    return (

        <BaseCadastro
            botoesExtra={botoesExtra}
            getModel={() => {

                const data = getFormData("notaFiscalEntrada", notaFiscalEntrada, anexos);
                return data;

            }}
            novoCadastro
            getNewModel={() => new NotaFiscalEntrada()}
            model={notaFiscalEntrada}
            service={notaFiscalEntradaService}
            setModel={(value: NotaFiscalEntrada) => {
                setAlterando(false)
                setNotaFiscalEntrada(value);
                setAnexos([])
            }} validar={() => validar()}
            urlService="/notaFiscalEntrada" pathCadastro="/notaFiscalEntrada" tituloPagina={'Nota Fiscal de Entrada'}>

            <PatrimonioPorNotaModal
                visible={patrimonioModal.visible}
                setVisible={(visible) => { setPatrimonioModal({ visible: visible, itemNota: new ItemNotaFiscalEntrada(), rowIndex: -1 }) }}
                fornecedor={notaFiscalEntrada.fornecedor}
                itemNota={patrimonioModal.itemNota}
                quantidade={patrimonioModal.itemNota.quantidade}
                onConfirm={(patrimoniosLista) => {
                    patrimonioModal.itemNota.patrimonios = patrimoniosLista;
                    const comps = [...notaFiscalEntrada.itens];
                    comps[patrimonioModal.rowIndex] = patrimonioModal.itemNota;

                    setNotaFiscalEntrada({ ...notaFiscalEntrada, itens: comps });
                    beforeFechar();
                }}
                onCancel={() => {
                    setContador(0);
                }}
            />

            <Dialog header="Cadastro de Produto" visible={visibleCadastroProduto} onHide={() => setVisibleCadastroProduto(false)} style={{ width: '75vw' }} >
                <ProdutoCadastro isModal onSave={() => {
                    setVisibleCadastroProduto(false);
                    notaFiscalEntradaService.getProdutosComprados().then((data) => {
                        setProdutos(data);
                    }).catch((error) => {
                        console.log(error);
                    });
                }} />
            </Dialog>

            {titulo ?
                <div className="row" style={{ marginBottom: 10 }}>
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Número</Label>
                <div className="col-sm-12">
                    <Controller name="numero" control={control} render={({ field }) => (
                        <InputNumber
                            inputRef={field.ref}
                            useGrouping={false}
                            className={errors.numero ? "p-invalid" : ""}
                            maxFractionDigits={0}
                            disabled={editando}
                            value={notaFiscalEntrada.numero}
                            style={{ width: '30%' }}
                            onChange={(e) => {
                                setAlterando(true);
                                setNotaFiscalEntrada({ ...notaFiscalEntrada, numero: e.value as number })
                                clearErrors("numero")
                            }}
                        />
                    )} />
                </div>
                {errors.numero && errors.numero.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.numero?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Fornecedor</Label>
                <div className="col-sm-12">
                    <Controller name="fornecedor" control={control} render={({ field }) => (
                        <AutoComplete
                            inputRef={field.ref}
                            dropdown
                            value={notaFiscalEntrada.fornecedor}
                            placeholder="Selecione um Fornecedor"
                            style={{ width: '30%' }}
                            field="nome"
                            itemTemplate={(item: Pessoa) => pessoaItemTemplate(item)}
                            suggestions={fornecedoresFiltrados}
                            completeMethod={(e) => {
                                let filtered: Pessoa[] = pessoaCompleteMethod(fornecedores, e.query);
                                setFornecedoresFiltrados(filtered);
                            }}
                            onChange={(e) => {
                                clearErrors("fornecedor")

                                let notaLocal = JSON.parse(JSON.stringify(notaFiscalEntrada));

                                if (!e.target.value) {
                                    notaLocal.fornecedor = null;
                                } else if (typeof e.target.value == "string") {
                                    let fornecedor = new Pessoa();
                                    fornecedor.nome = e.target.value;
                                    notaLocal.fornecedor = fornecedor;
                                } else {
                                    notaLocal.fornecedor = e.target.value;
                                }
                                setAlterando(true);
                                setNotaFiscalEntrada(notaLocal);
                            }}
                        />
                    )} />
                </div>
                {errors.fornecedor && errors.fornecedor.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.fornecedor?.message as string}</span> : null}
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <Label className="col-sm-12" obrigatorio>Transação</Label>
                    <div class-name="col-sm-12">
                        <Controller name="transacao" control={control} render={({ field }) => (
                            <Dropdown
                                focusInputRef={field.ref}
                                className={errors.transacao ? "p-invalid" : ""}
                                value={notaFiscalEntrada.transacao} options={transacoes}
                                onChange={(e) => {
                                    setAlterando(true);
                                    clearErrors("transacao");
                                    setNotaFiscalEntrada({ ...notaFiscalEntrada, transacao: e.value });
                                }}
                                optionLabel="descricao" style={{ width: '30%' }}
                            />)} />
                    </div>
                    {errors.transacao && errors.transacao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.transacao?.message as string}</span> : null}
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Data Recebimento</Label>
                <div className="col-sm-12">
                    <InputText disabled value={notaFiscalEntrada.dataRecebimento ? converterDataHora(notaFiscalEntrada.dataRecebimento) : ""} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Usuário</Label>
                <div className="col-sm-12">
                    <InputText disabled value={notaFiscalEntrada?.usuario?.nome} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Status</Label>
                <div className="col-sm-12">
                    <InputText disabled value={notaFiscalEntradaService.getStatus(notaFiscalEntrada.status)} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <AnexoPanel
                        novosAnexos={anexos} onChangeNovosAnexos={(e: any) => setAnexos(e)}
                        arquivos={notaFiscalEntrada.arquivos} onChange={(e) => {
                            console.log(e)
                            setAlterando(true);
                            setNotaFiscalEntrada({ ...notaFiscalEntrada, arquivos: e })
                        }}
                        collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col col-sm-12 mt-2">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Itens"
                        getNewModel={() => new ItemNotaFiscalEntrada()}
                        dataKey="key"
                        lista={notaFiscalEntrada ? notaFiscalEntrada.itens : []}
                        setLista={(value: ItemNotaFiscalEntrada[]) => {
                            setAlterando(true);
                            setNotaFiscalEntrada({ ...notaFiscalEntrada, itens: value });
                        }}
                        onRowReorder={(e) => {
                            e.value.forEach((item: any, index: number) => {
                                item.sequencial = index + 1;
                            });
                            if (notaFiscalEntrada) {
                                notaFiscalEntrada.itens = e.value as ItemNotaFiscalEntrada[];
                                setNotaFiscalEntrada({ ...notaFiscalEntrada });
                            }
                        }}
                        reordable={true}
                        scrollHeight="500px"
                        scrollable={true}
                    >
                        <Column rowReorder style={{ width: '3em' }} />
                        <Column field="sequencial" header="Seq." style={{ width: '5%' }} />
                        <Column field="itemPatrimonio" header="Patrimônio?"
                            body={(rowData, options: ColumnBodyOptions) =>
                                <Checkbox disabled={notaFiscalEntrada.status === 'FECHADO'} checked={rowData.itemPatrimonio} />
                            }
                            editor={(options) => {
                                return <Checkbox disabled={notaFiscalEntrada.status === 'FECHADO'} checked={options.rowData.itemPatrimonio}
                                    onChange={(e) => {
                                        options.rowData.itemPatrimonio = e.checked;
                                        options.rowData.produto = null;
                                        options.rowData.lote = '';
                                        options.rowData.validade = null;
                                        options.rowData.deposito = null;
                                        options.rowData.local = null;
                                        options.rowData.quantidade = 0;

                                        let notaFiscalEntradaLocal = { ...notaFiscalEntrada };
                                        notaFiscalEntradaLocal.itens[options.rowIndex] = {
                                            ...options.rowData,
                                            produto: null,
                                            lote: '',
                                            validade: null,
                                            deposito: null,
                                            local: null
                                        };
                                        notaPatrimonio();

                                        setNotaFiscalEntrada(notaFiscalEntradaLocal);
                                    }}
                                />
                            }}
                        />

                        <Column header="Dep/Local" style={{ width: '10%' }} body={(rowData) => rowData.itemPatrimonio ? rowData.local?.nome : rowData.deposito?.nome} editor={(options) => {
                            return options.rowData.itemPatrimonio ? localEditor(options) : depositoEditor(options)
                        }} />
                        <Column field="produto.nome" header="Produto" style={{ width: '30%' }} editor={(options) => produtoEditor(options)} />
                        <Column field="quantidade" header="Quantidade" style={{ width: '5%' }} editor={(options) => quantidadeEditor(options)} />
                        {soPatrimonio ? null : <Column field="valorUnitario" header="Valor Unitário" body={(rowData) => `R$` + (rowData.valorUnitario).toFixed(2)} style={{ width: '10%' }} editor={(options) => valorUnitarioEditor(options)} />}
                        {soPatrimonio ? null : <Column field="lote" header="Lote" style={{ width: '10%' }} editor={(options) => loteEditor(options)} />}
                        {soPatrimonio ? null : <Column field="validade" body={(rowData) => converterData(rowData.validade)} header="Validade" style={{ width: '20%' }} editor={(options) => validadeEditor(options)} />}
                    </BaseDataTableEdit>
                </div>
            </div>

        </BaseCadastro>
    )
}
